import getLogger from "../../logger/index";
import { config } from "api/config";
export const NEARBY_REQUEST = "NEARBY_REQUEST";
export const NEARBY_SUCCESS = "NEARBY_SUCCESS";
export const NEARBY_FAILURE = "NEARBY_FAILURE";
export const REQUESTING = "Requesting";
export const SUCCESS = "Success";
export const ERROR = "Error";
const log = getLogger("NEARBY_REQUEST");
import { post } from "util/apiRequest";
import { getDynamicRoute } from "util/createProfileIdPath";

export function nearbyRequest() {
  return {
    type: NEARBY_REQUEST,
    status: REQUESTING,
  };
}
export function nearbySuccess(nearby) {
  return {
    type: NEARBY_SUCCESS,
    status: SUCCESS,
    nearby,
  };
}
export function nearbyFailure(error) {
  return {
    type: NEARBY_FAILURE,
    status: ERROR,
    error,
  };
}

export function nearby(city, stateCode, postalCode) {
  return async (dispatch) => {
    try {
      if ((city && stateCode) || postalCode) {
        dispatch(nearbyRequest());
        const url = `${config.GATEWAY_URL}/${getDynamicRoute()}/api/v3/nearby`;
        const body = {
          city: city || null,
          stateCode: stateCode || null,
          postalCode: postalCode || null,
        };
        let nearByInformations = await post(url, body, 5000);
        nearByInformations =
          nearByInformations.data && nearByInformations.data.data
            ? nearByInformations.data.data
            : null;
        return dispatch(nearbySuccess(nearByInformations));
      } else {
        return;
      }
    } catch (error) {
      const req = {
        city: city || null,
        stateCode: stateCode || null,
        postalCode: postalCode || null,
      };
      log.error(
        "Error while fetching GEO API data for the Request : " + JSON.stringify(req),
        error,
      );
      dispatch(nearbyFailure(error.message));
    }
  };
}
